
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Console extends Vue {

  ruleLightboxHandler(target: string) {
    this.$store.commit('FreeCellStore/SET_LIGHTBOX', target)
  }
}
